import { createSelector } from "../../../utils/createSelector.es.js";
const gridDensitySelector = (state) => state.density;
const gridDensityValueSelector = createSelector(gridDensitySelector, (density) => density.value);
const gridDensityFactorSelector = createSelector(gridDensitySelector, (density) => density.factor);
export {
  gridDensityFactorSelector,
  gridDensitySelector,
  gridDensityValueSelector
};
//# sourceMappingURL=densitySelector.es.js.map
